/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loud_East_Swallow_GrinInputs */

const fr_loud_east_swallow_grin = /** @type {(inputs: Loud_East_Swallow_GrinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir`)
};

/**

* @param {Loud_East_Swallow_GrinInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const loud_east_swallow_grin = /** @type {((inputs?: Loud_East_Swallow_GrinInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loud_East_Swallow_GrinInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_loud_east_swallow_grin(inputs)
});